module.exports = __webpack_public_path__ + "static/media/intro_bomen.2e0d78a7.png";